@file:Suppress("TooGenericExceptionCaught")
package com.klantenstop.web.pages.admin.curatedcities

import com.klantenstop.web.data.repos.CuratedCityRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class CuratedCitiesViewModel(
    private val curatedCityRepo: CuratedCityRepo = CuratedCityRepo
) : ViewModel(), CuratedCitiesContract {

    private val _state = MutableStateFlow(CuratedCitiesContract.State())
    override val state: StateFlow<CuratedCitiesContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<CuratedCitiesContract.Effect>()
    override val effect: SharedFlow<CuratedCitiesContract.Effect> = _effect.asSharedFlow()

    override fun sendIntent(intent: CuratedCitiesContract.Intent) = coroutineScope.launch {
        when (intent) {
            is CuratedCitiesContract.Intent.NavigateToManage ->
                emitEffect(CuratedCitiesContract.Effect.NavigateToManage(intent.curatedCityId))

            is CuratedCitiesContract.Intent.LoadCuratedCities -> loadCuratedCities()
            is CuratedCitiesContract.Intent.DeleteCuratedCity -> deleteCuratedCity(intent.curatedCityId)
            is CuratedCitiesContract.Intent.SetCuratedCityToDelete -> updateState { it.copy(curatedCityToDelete = intent.curatedCity) }
        }
    }

    override fun emitEffect(effect: CuratedCitiesContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (CuratedCitiesContract.State) -> CuratedCitiesContract.State) {
        _state.update(block)
    }

    private suspend fun loadCuratedCities() {
        updateState { it.copy(isLoading = true) }

        try {
            val curatedCities = curatedCityRepo.getCuratedCities()
            updateState {
                it.copy(
                    curatedCities = curatedCities,
                    isLoading = false
                )
            }
        } catch (e: Exception) {
            updateState { it.copy(isLoading = false) }
            emitEffect(CuratedCitiesContract.Effect.ShowError(e.message ?: "Fout bij het ophalen van steden"))
        }
    }

    private suspend fun deleteCuratedCity(curatedCityId: String) {
        updateState { it.copy(isLoading = true) }

        try {
            curatedCityRepo.deleteCuratedCity(curatedCityId)
            emitEffect(CuratedCitiesContract.Effect.ShowSuccess("Stad verwijderd"))
            loadCuratedCities()
        } catch (e: Exception) {
            updateState { it.copy(isLoading = false) }
            emitEffect(CuratedCitiesContract.Effect.ShowError(e.message ?: "Fout bij het verwijderen van stad"))
        } finally {
            updateState { it.copy(curatedCityToDelete = null) }
        }
    }
}
